import { render, staticRenderFns } from "./RouterButton.vue?vue&type=template&id=6b68cc99&scoped=true"
import script from "./RouterButton.vue?vue&type=script&lang=js"
export * from "./RouterButton.vue?vue&type=script&lang=js"
import style0 from "./RouterButton.vue?vue&type=style&index=0&id=6b68cc99&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b68cc99",
  null
  
)

export default component.exports